import axiosConfig from "../data/utils/axiosConfigInstance";
import { baseUrl } from "../data/utils/globals";

export const updatePopUpState = async(popupId) => {
   
    if(!popupId) {
        return ;
    }
    const response = await axiosConfig.post(`${baseUrl}/popup/viewed`,{
        popupId
    } )
    return response;

}